// Job posting is available on every plan. ATS access only selects how candidates apply.
export const hasHostedJobApplications = ({ hasAccess, productTypes = [] }) => Boolean(
  hasAccess && (productTypes.includes('ats') || productTypes.includes('bundle'))
);

export const normalizeJobApplicationTarget = (value) => {
  const target = String(value || '').trim();
  if (!target) return null;

  const email = target.replace(/^mailto:/i, '');
  if (/^[^\s@:/?#]+@[^\s@:/?#]+\.[^\s@:/?#]+$/.test(email)) {
    return `mailto:${email}`;
  }
  if (/^mailto:/i.test(target) || /\s/.test(target)) return null;

  try {
    const url = new URL(/^[a-z][a-z\d+.-]*:/i.test(target) ? target : `https://${target}`);
    if (!['https:', 'http:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) {
      return null;
    }
    return url.href;
  } catch {
    return null;
  }
};

export const normalizeWhatsAppNumber = (value) => {
  const compact = String(value || '').trim().replace(/[\s().-]/g, '');
  if (!/^\+?[1-9]\d{7,14}$/.test(compact)) return null;
  return compact.replace(/^\+/, '');
};

export const buildWhatsAppApplicationTarget = (value) => {
  const number = normalizeWhatsAppNumber(value);
  return number ? `https://wa.me/${number}` : null;
};

export const getWhatsAppNumberFromTarget = (value) => {
  try {
    const url = new URL(String(value || ''));
    if (url.protocol !== 'https:' || url.hostname !== 'wa.me') return null;
    return /^\/[1-9]\d{7,14}\/?$/.test(url.pathname)
      ? url.pathname.replace(/\D/g, '')
      : null;
  } catch {
    return null;
  }
};
